import Vue from 'vue';

import BlockHeadline from './UI/BlockHeadline';
import SectionHeadline from './UI/SectionHeadline';
import BueroForm from './Form/BueroForm';
import FormButtons from './UI/FormButtons';
import Buttons from './UI/Buttons';
import Loader from './UI/Loader';
import NoData from './UI/NoData';
import SearchBar from './SearchableList/SearchBar';
import VueCropper from 'vue-cropperjs';
import SearchableList from './SearchableList/SearchableList';
import SearchableListElementWithFile from './SearchableList/SearchableListElementWithFile';
import SearchableListElementWithImage from './SearchableList/SearchableListElementWithImage';
import Badge from './UI/Badge';

Vue.component('block-headline', BlockHeadline);
Vue.component('section-headline', SectionHeadline);
Vue.component('buero-form', BueroForm);
Vue.component('form-buttons', FormButtons);
Vue.component('buttons', Buttons);
Vue.component('loader', Loader);
Vue.component('no-data', NoData);
Vue.component('search-bar', SearchBar);
Vue.component('vue-cropper', VueCropper);
Vue.component('searchable-list', SearchableList);
Vue.component('searchable-list-element-with-file', SearchableListElementWithFile);
Vue.component('searchable-list-element-with-image', SearchableListElementWithImage);
Vue.component('badge', Badge);
